import { t } from '@lingui/macro';
import { i18n } from '../utils/setupTranslations';
import { FormFields, FormKeys } from '../types';

export const fieldOrder: Array<keyof FormFields> = [
    FormKeys.PackName,
    FormKeys.Description,
    FormKeys.LabelName,
    FormKeys.PackGenre,
    FormKeys.PackSubgenre,
    FormKeys.Exclusivity,
    FormKeys.Lexicon,
];

export const fieldTitles: { [key in keyof FormFields]: string } = {
    [FormKeys.PackName]: i18n._(t`Pack Name`),
    [FormKeys.Description]: i18n._(t`Description`),
    [FormKeys.LabelName]: i18n._(t`Label Name`),
    [FormKeys.PackGenre]: i18n._(t`Pack Genre`),
    [FormKeys.PackSubgenre]: i18n._(t`Pack Subgenre`),
    [FormKeys.Exclusivity]: i18n._(t`Exclusivity`),
    [FormKeys.Lexicon]: i18n._(t`Metadata categories`),
};

export const fieldDescriptions: {
    [key in keyof Partial<FormFields>]: string;
} = {
    [FormKeys.PackName]: i18n._(
        t`Please let us know the exact name of the sample pack as you want it to be displayed on the site`,
    ),
    [FormKeys.Description]: i18n._(
        t`Please provide us with a description of your sample pack. Do not include any reference to MIDI or preset files`,
    ),
    [FormKeys.LabelName]: i18n._(t`Please fill in your exact label name`),
};
